export default function Manifesto() {
  return (
    <section
      id="services"
      data-stage="1"
      className="relative min-h-[65vh] w-full flex items-start justify-center overflow-hidden pt-32 md:pt-40"
    >

      <div className="relative z-10 w-full max-w-5xl px-6 md:px-12 text-center">
        <h2
          data-reveal
          data-delay="1"
          className="font-syncopator text-[19vw] sm:text-[16vw] md:text-[8.5rem] lg:text-[10rem] leading-[1.08] md:leading-[0.92] text-black font-light tracking-tightest drop-shadow-[0_4px_24px_rgba(0,0,0,0.35)]"
        >
          Vielleicht.
        </h2>
      </div>
    </section>
  );
}